import moment from 'moment'

import dateTimeZonedMask from './dateTimeZonedMask'

const dateToStrTimezone = (
    date?: moment.MomentInput,
    mask: string = dateTimeZonedMask,
): string | null => {
    if (!date) {
        return null
    }

    return moment.parseZone(date).format(mask)
}

export default dateToStrTimezone
